module.exports = __webpack_public_path__ + "assets/202509252035/img/suka.fec81ad5.jpg";